import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class ShipmentService {
    constructor(private http: AuthHttp) { }

    getShipmentTypes() {
        return this.http.get(AppSettings.apiEndpoint + 'ShipmentType/GetShipmentTypes')
            .map((response: Response) => response.json());
    }
    
    getShipmentModes() {
        return this.http.get(AppSettings.apiEndpoint + 'ShipmentMode/GetShipmentModes')
            .map((response: Response) => response.json());
    }    
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/shipment.service.ts